import React, { useState, useContext } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import styles from "./Auth.module.css";
import buttonStyles from "../styles/Buttons.module.css";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Spinner from "../components/Spinner";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [errors, setErrors] = useState({});
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const validate = () => {
    const errs = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    if (!email.trim()) {
      errs.email = "El email es obligatorio.";
    } else if (!emailRegex.test(email.trim())) {
      errs.email = "Correo electrónico inválido.";
    }
    if (!pass) {
      errs.pass = "La contraseña es obligatoria.";
    }

    return errs;
  };

  const submit = async e => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    try {
      setLoading(true);
      await login(email.trim(), pass);
      navigate("/courses");
    } catch (err) {
      setErrors({ global: "Error al iniciar sesión. Verifica tus credenciales." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <h2 className={styles.title}>Iniciar Sesión</h2>
        {errors.global && <p className={styles.error}>{errors.global}</p>}
        <form onSubmit={submit} className={styles.form} noValidate>
          <div className={styles.inputWrapper}>
            <FaEnvelope className={styles.icon} />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className={styles.input}
              aria-label="Correo electrónico"
              autoComplete="email"
            />
          </div>
          {errors.email && <span className={styles.error}>{errors.email}</span>}

          <div className={styles.inputWrapper}>
            <FaLock className={styles.icon} />
            <input
              type={showPass ? "text" : "password"}
              placeholder="Contraseña"
              value={pass}
              onChange={e => setPass(e.target.value)}
              required
              className={styles.input}
              aria-label="Contraseña"
              autoComplete="current-password"
            />
            {showPass ? (
              <FaEye
                className={styles.toggleIcon}
                onClick={() => setShowPass(false)}
                title="Ocultar contraseña"
              />
            ) : (
              <FaEyeSlash
                className={styles.toggleIcon}
                onClick={() => setShowPass(true)}
                title="Mostrar contraseña"
              />
            )}
          </div>
          {errors.pass && <span className={styles.error}>{errors.pass}</span>}

          <button type="submit" className={buttonStyles.btnPrimary} disabled={loading}>
            {loading ? <Spinner size={18} /> : "Entrar"}
          </button>
        </form>

        <p className={styles.footerText}>
          ¿No tienes cuenta? <Link to="/register" className={styles.link}>Regístrate</Link>
        </p>
        <p className={styles.footerText}>
          ¿Olvidaste tu contraseña?{" "}
          <Link to="/forgot-password" className={styles.link}>
            Recuperarla
          </Link>
        </p>
      </div>
    </div>
  );
}
